var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser1077114(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_1077114",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20.376,
    viewBox: "0 0 17 20.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_63349",
    "data-name": "Path 63349",
    d: "M92.016,9.605A4.916,4.916,0,0,0,95.54,8.2,4.563,4.563,0,0,0,97,4.8a4.564,4.564,0,0,0-1.46-3.4,5.118,5.118,0,0,0-7.049,0,4.564,4.564,0,0,0-1.46,3.4,4.563,4.563,0,0,0,1.461,3.4A4.918,4.918,0,0,0,92.016,9.605Zm0,0",
    transform: "translate(-83.642)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_63350",
    "data-name": "Path 63350",
    d: "M16.959,253.018a11.621,11.621,0,0,0-.165-1.26,9.752,9.752,0,0,0-.317-1.267,6.189,6.189,0,0,0-.532-1.181,4.471,4.471,0,0,0-.8-1.023,3.549,3.549,0,0,0-1.153-.709,4.061,4.061,0,0,0-1.472-.261,1.512,1.512,0,0,0-.8.331c-.239.153-.519.329-.831.524a4.815,4.815,0,0,1-1.075.464,4.261,4.261,0,0,1-2.63,0,4.8,4.8,0,0,1-1.074-.463c-.309-.193-.589-.37-.832-.525a1.51,1.51,0,0,0-.8-.331,4.056,4.056,0,0,0-1.471.261,3.547,3.547,0,0,0-1.153.709,4.472,4.472,0,0,0-.8,1.023,6.2,6.2,0,0,0-.532,1.182,9.775,9.775,0,0,0-.317,1.267,11.58,11.58,0,0,0-.165,1.26C.014,253.4,0,253.8,0,254.2A3.274,3.274,0,0,0,1,256.7a3.664,3.664,0,0,0,2.589.924h9.811a3.663,3.663,0,0,0,2.589-.924A3.273,3.273,0,0,0,17,254.2C17,253.794,16.986,253.4,16.959,253.018Zm0,0",
    transform: "translate(0 -237.249)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1077114);
export default __webpack_public_path__ + "static/media/user_1077114.497bc5ebbeaab33418738cb6bace68de.svg";
export { ForwardRef as ReactComponent };